import { render, staticRenderFns } from "./NotificacaoMensagemLista.vue?vue&type=template&id=4021d80a&scoped=true"
import script from "./NotificacaoMensagemLista.vue?vue&type=script&lang=js"
export * from "./NotificacaoMensagemLista.vue?vue&type=script&lang=js"
import style0 from "./NotificacaoMensagemLista.vue?vue&type=style&index=0&id=4021d80a&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4021d80a",
  null
  
)

export default component.exports